<div class="subtitle h2">{{ 'main-page-subscription.question' | translate }}</div>
  <div class="recommendations">
    <div class="recommendation" *ngIf="!privetPlus">
      <div class="recommendation__content">
        <div class="recommendation__title">{{ 'main-page-subscription.change-tracks' | translate }}</div>
        <div class="recommendation__text">{{ 'main-page-subscription.privet-plus-hint' | translate }}</div>
      </div>
      <div class="recommendation__button">
        <div  class="button button_type_recommendation" (click)="activatePrivetPlus()">
          <div class="button__text">{{ 'main-page-subscription.activate-privet-plus' | translate }}</div>
          <div class="button__subtext">{{ 'main-page-subscription.privet-plus-price' | translate }}</div>
        </div>
      </div>
    </div>
    <div class="recommendation" *ngIf="!privet">
      <div class="recommendation__content">
        <div class="recommendation__title">{{ 'main-page-subscription.one-track-long-time' | translate }}</div>
        <div class="recommendation__text">{{ 'main-page-subscription.privet-hint' | translate }}</div>
      </div>
      <div class="recommendation__button">
        <div class="button button_type_recommendation button_type_light" (click)="activatePrivet()">
          <div class="button__text">{{ 'main-page-subscription.activate-privet' | translate }}</div>
          <div class="button__subtext">{{ 'main-page-subscription.privet-price' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
